/* eslint max-lines: off */
import React from 'react';
import { useSelector } from 'react-redux';

import selectors from 'state/selectors';
import utils from 'utils';

import Modal from 'components/Modal';
import Table, { TableProps } from 'components/Table';

const ErrorMultiConvalidation = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);

  const columns: TableProps['columns'] = [
    {
      Header: t('protocol_in'),
      accessor: 'protocol_in',
    },
    {
      Header: t('error-description'),
      accessor: 'response',
      width: 500,
    },
  ];

  return (
    <>
      <Modal.Header title={t('multiple-confirm-error-title')} subtitle={t('multilple-confirm-error-desc')} />
      <Modal.Content>
        {modalProps.list && modalProps.list.length ? (
          <Table
            id="multiple-confirm-error-table"
            rowId="protocol"
            hasSort
            columns={columns}
            rows={modalProps.list}
            hasPagination
            hasResize
          />
        ) : null}
      </Modal.Content>
    </>
  );
};

export default ErrorMultiConvalidation;
